<template>

  <div>
    <!-- 创建容器 -->
    <div id="mountNode"></div>
  </div>

</template>

<script>
import G6 from '@antv/g6'

export default {
  name:"line",
  data(){
    return {
      defaultConfig:{
          width: 2100,
          height: 800,
          modes: {
            default: ['zoom-canvas', 'drag-canvas']
          },
          fitView: true, // 开启画布自适应。开启后图自动适配画布大小
          animate: true,
          // 节点样式
          defaultNode: {
            type: 'flow-rect', // flow-rect我们自定义的样式名称，告诉画板要引用哪个模块
            style: {
              fill: '#0095FF' // 默认的模板填充色
            },
            // 默认的模板的文字的填充色
            labelCfg: {
              style: {
                fill: '#fff',
                fontSize: 20,
                fontWeight: 800
              }
            }
          },
          // 线的样式
          defaultEdge: {
            type: 'polyline',
            size: 3, // 粗细
            style: {
              stroke: '#CED4D9'
            }
          },
          // 布局
          layout: {
            type: 'compactBox', // 布局类型
            direction: 'TB', // 展开的方向
            // 与子节点的相差的高度
            getHeight: () => {
              return 150
            },
            // 与子节点的相差的宽度
            getWidth: () => {
              return 200
            }
          },
          maxZoom: 1 // 展开时的放缩比例
      },
      data:{
        label:'顺德太平洋鼎旺商业中心项目线路',
        children:[
            {
              id: '1',
              peopleName: '10kV朱鼎甲线',
              jiugongPosition: '仪表数量：',
              jiugongValue: 46,
              successors: '下级仪表数量：',
              successorsValue: 13,
              children: [
                {
                  id: '174045',
                  peopleName: '生活水泵房电表',
                  jiugongPosition: '仪表数量',
                  jiugongValue: 0,
                  successors: '下级仪表数量',
                  successorsValue: 0,
                },
                {
                  id: '174046',
                  peopleName: '物业办公电表',
                  jiugongPosition: '仪表数量',
                  jiugongValue: 0,
                  successors: '下级仪表数量',
                  successorsValue: 0,
                },
                {
                  id: '174047',
                  peopleName: '消防控制中心用电',
                  jiugongPosition: '仪表数量',
                  jiugongValue: 0,
                  successors: '下级仪表数量',
                  successorsValue: 0,
                },
                {
                  id: '174048',
                  peopleName: '北面广场路灯',
                  jiugongPosition: '仪表数量',
                  jiugongValue: 0,
                  successors: '下级仪表数量',
                  successorsValue: 0,
                },
                {
                  id: '174049',
                  peopleName: '中奥饭堂电表',
                  jiugongPosition: '仪表数量',
                  jiugongValue: 0,
                  successors: '下级仪表数量',
                  successorsValue: 0,
                },
                {
                  id: '174050',
                  peopleName: '中央空调主机电表',
                  jiugongPosition: '仪表数量',
                  jiugongValue: 0,
                  successors: '下级仪表数量',
                  successorsValue: 0,
                },
                {
                  id: '174051',
                  peopleName: '中央空调水泵电表',
                  jiugongPosition: '仪表数量',
                  jiugongValue: 0,
                  successors: '下级仪表数量',
                  successorsValue: 0,
                },
                {
                  id: '174052',
                  peopleName: '14层总电表',
                  jiugongPosition: '仪表数量',
                  jiugongValue: 0,
                  successors: '下级仪表数量',
                  successorsValue: 0,
                },
                {
                  id: '174053',
                  peopleName: '15层总电表',
                  jiugongPosition: '仪表数量',
                  jiugongValue: 5,
                  successors: '下级仪表数量',
                  successorsValue: 5,
                  children:[
                    {
                      id: '174056',
                      peopleName: '五楼外墙广告牌电表',
                      jiugongPosition: '仪表数量',
                      jiugongValue: 0,
                      successors: '下级仪表数量',
                      successorsValue: 0,
                    },
                    {
                      id: '174057',
                      peopleName: '15层安德公司总电表',
                      jiugongPosition: '仪表数量',
                      jiugongValue: 0,
                      successors: '下级仪表数量',
                      successorsValue: 0,
                    },
                    {
                      id: '174058',
                      peopleName: '15层华瑞公司总电表',
                      jiugongPosition: '仪表数量',
                      jiugongValue: 0,
                      successors: '下级仪表数量',
                      successorsValue: 0,
                    },
                    {
                      id: '174059',
                      peopleName: '14层展厅用电电表',
                      jiugongPosition: '仪表数量',
                      jiugongValue: 0,
                      successors: '下级仪表数量',
                      successorsValue: 0,
                    },
                    {
                      id: '174060',
                      peopleName: '15层空置公司总电表',
                      jiugongPosition: '仪表数量',
                      jiugongValue: 0,
                      successors: '下级仪表数量',
                      successorsValue: 0,
                    },
                  ]
                },
                {
                  id: '174054',
                  peopleName: '16层总电表',
                  jiugongPosition: '仪表数量',
                  jiugongValue: 7,
                  successors: '下级仪表数量',
                  successorsValue: 2,
                },
                {
                  id: '174055',
                  peopleName: '17层总电表',
                  jiugongPosition: '仪表数量',
                  jiugongValue: 7,
                  successors: '下级仪表数量',
                  successorsValue: 2,
                },
                {
                  id: '174089',
                  peopleName: 'B1栋电梯客梯用电',
                  jiugongPosition: '仪表数量',
                  jiugongValue: 0,
                  successors: '下级仪表数量',
                  successorsValue: 0,
                },
                {
                  id: '174090',
                  peopleName: 'B1栋消防梯用电',
                  jiugongPosition: '仪表数量',
                  jiugongValue: 0,
                  successors: '下级仪表数量',
                  successorsValue: 0,
                },

              ]
            }
        ],
      },
    }
  },
  created() {

  },
  mounted() {

        const data = {
          label: this.data.label,
          type: 'rect',
          size: [300, 40],
          anchorPoints: [
            [0.5, 0],
            [0.5, 1]
          ],
          getHeight: () => {
            return 10
          },
          getWidth: () => {
            return 150
          },
          children: this.data.children
        }
        const colors = {
          A: '#D6F3DA',
          B: '#FDEBD3',
          C: '#D7D7D7'
        }
        // 默认配置
        var defaultConfig = this.defaultConfig;
        // 自定义节点和边
        const registerFn = () => {
          /**
           * 自定义节点
           */
          G6.registerNode(
            'flow-rect', // 自定义的节点名称，在上面进行引用
            {
              shapeType: 'flow-rect',
              // 这里涉及到模板的生命周期函数，官网上面有详细的讲解
              draw(cfg, group) {
                const { colorIndex, organizationName, postName, peopleName, jiugongPosition, jiugongValue, successors, successorsValue, successionReadiness, successionReadinessValue } = cfg
                // 自定义模板
                const rectConfig = {
                  width: 214,
                  height: 147,
                  fill: '#fff',
                  shadowOffsetX: 0, // 模板阴影的X轴偏移量
                  shadowOffsetY: 0, // 模板阴影的Y轴偏移量
                  shadowColor: '#999',
                  shadowBlur: 10
                }
                // 规定边界，便于定位
                const nodeOrigin = {
                  x: -rectConfig.width / 2,
                  y: -rectConfig.height / 2
                }
                // 规定文字位置，对齐方式
                const textConfig = {
                  textAlign: 'left',
                  textBaseline: 'bottom'
                }
                // 初始化模板
                const rect = group.addShape('rect', {
                  attrs: {
                    x: nodeOrigin.x,
                    y: nodeOrigin.y,
                    ...rectConfig
                  }
                })

                // 背景板
                group.addShape('rect', {
                  attrs: {
                    x: nodeOrigin.x, // x轴位置
                    y: nodeOrigin.y, // y轴位置
                    width: 214,
                    height: 50,
                    // radius: [0, 0, rectConfig.radius, rectConfig.radius],//锐角化
                    fill: colors[colorIndex] // 填充色
                  }
                })

                // 线路名称
                group.addShape('text', {
                  attrs: {
                    ...textConfig,
                    x: 9 + nodeOrigin.x,
                    y: 25 + nodeOrigin.y,
                    text: peopleName,
                    height: 18,
                    fontSize: 16,
                    fontWeight: 800,
                    fill: '#333',
                    opacity: 1
                  }
                })

                // 间隔线
                group.addShape('rect', {
                  attrs: {
                    x: 4 + nodeOrigin.x,
                    y: 30 + nodeOrigin.y,
                    width: 204,
                    height: 1,
                    fill: '#333',
                    opacity: 0.35
                  }
                })

                // 线路总数量
                group.addShape('text', {
                  attrs: {
                    ...textConfig,
                    x: 9 + nodeOrigin.x,
                    y: 60 + nodeOrigin.y,
                    text: jiugongPosition,
                    fontSize: 16,
                    fill: '#555',
                    opacity: 1
                  }
                })
                group.addShape('text', {
                  attrs: {
                    ...textConfig,
                    x: -(60 + nodeOrigin.x),
                    y: 60 + nodeOrigin.y,
                    text: jiugongValue,
                    fontSize: 16,
                    fontWeight: 800,
                    fill: '#555',
                    opacity: 1
                  }
                })

                // 线路总数量下级表数量
                group.addShape('text', {
                  attrs: {
                    ...textConfig,
                    x: 9 + nodeOrigin.x,
                    y: 95 + nodeOrigin.y,
                    text: successors,
                    fontSize: 16,
                    fill: '#555',
                    opacity: 1
                  }
                })
                group.addShape('text', {
                  attrs: {
                    ...textConfig,
                    x: -(60 + nodeOrigin.x),
                    y: 95 + nodeOrigin.y,
                    text: successorsValue,
                    fontSize: 16,
                    fontWeight: 800,
                    fill: '#555',
                    opacity: 1
                  }
                })

                // 跳转
                // group.addShape('image', {
                //   attrs: {
                //     x: -nodeOrigin.x - 36,
                //     y: 12 + nodeOrigin.y,
                //     img: require('@/assets/logo.png'),
                //     width: 26,
                //     height: 26,
                //     cursor: 'pointer'
                //   },
                //   name: 'deleteItem'
                // })


                return rect
              },
              // 定义锚点，G6会自动连接两个节点的最近的锚点
              getAnchorPoints() {
                return [
                  // [0, 0.5], // 左侧中间
                  // [1, 0.5], // 右侧中间
                  [0.5, 0], // 上侧中间
                  [0.5, 1] // 下侧中间
                ]
              }
            },
            'rect'
          )
        }
        registerFn()
        // 画布主体
        const treeGraph = new G6.TreeGraph({
          container: 'mountNode', // 制定画布的容器
          ...defaultConfig
        })

        // deleteItem: 对于需要单独操作的元素，请在定义数据的时候定义nama值，这样才可以定位到指定元素
        treeGraph.on('deleteItem:click', (ev) => {
          const shape = ev.target
          const node = ev.item
          console.log(shape)
          console.log(node)
        })
        treeGraph.data(data) // 加载数据
        treeGraph.render() // 渲染
  },
  methods:{
    initGraph(){



    }

  }
}
</script>

<style>
</style>



// WEBPACK FOOTER //
// src/components/Admin/SecpMeter/LineStructure.vue